import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CommonModule, NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { GlobalService } from '../../_services/global.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SimpleSearchComponent } from '../../components/simple-search/simple-search.component';
import { AdvanceSearchComponent } from '../../components/advance-search/advance-search.component';
import { DynamicSearchComponent } from '../../components/dynamic-search/dynamic-search.component';
import { AuthenticationService } from '../../_services/authentication.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { user_privilege } from '../../../_model/user_privilege';
import { search_filter } from '../../../_model/search_fliter';
import { CommanService } from '../../_services/comman.service';
import { BusyService } from '../../_services/busy.service';
import { ConstantService } from '../../_services/constant.service';
import { HttpClient } from '@angular/common/http';
import { SidebarComponent } from "../../components/sidebar/sidebar.component";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgFor,
    NgIf,
    NgStyle,
    NgClass,
    RouterLink,
    SimpleSearchComponent,
    AdvanceSearchComponent,
    DynamicSearchComponent,
    CommonModule,
    SidebarComponent
],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  @ViewChild('priviledgeModal') priviledgeModal!: ElementRef;
  @ViewChild('aboutVideo') aboutVideo: any;
  @ViewChild('IntroVideo') IntroVideo: any;
  @ViewChild('SimpleSearchComponent')
  SimpleSearchComponent!: SimpleSearchComponent;
  @ViewChild('DynamicSearchComponent')
  DynamicSearchComponent!: DynamicSearchComponent;
  @ViewChild('AdvanceSearchComponent')
  AdvanceSearchComponent!: AdvanceSearchComponent;

  searchQueryGrid: string = '';
  isShowTable: boolean = false;
  filterForm_normal: FormGroup = new FormGroup({});
  isSignedIn = false;
  searchValueFromEmail: string | null = null;
  selectedSearchOption = 0;
  // clients: any = [];
  platforms: any = [];
  services: any = [];
  testimonials: any = [];
  transparent = true;
  isVisible = false;
  platformLogoUrl = 'https://www.chemrobotics.com/assets/images/megamenu-icon/';
  clientLogoUrl = 'https://www.chemrobotics.com/agropat/uploads/client_logo/';
  introVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-Agrochemical-Pharmaceutical-Fine-Chemical-Database-Patents.mp4';
  aboutIntoVideo =
    'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
  aboutThumbnail =
    'https://www.chemrobotics.com/assets/images/banner/about-banner.png';
  wedoThumbnail = '../../../assets/img/what_we_do.png';
  serviceLogoUrl = '../../../assets/icons/';
  selectedItem: number = 0;
  tabvalue: any;
  showTab: any;
  auth: boolean = false;
  LimitValue: any;
  message: any = '';
  userid: any = '';
  gbrn: any = '';
  currentFilterCondition: any;
  INCHIKEY: any = '';
  cols: any = '';
  columns: any = '';
  totalRecords: any = '';
  privilege_json!: user_privilege;
  application_query: string = '';
  user_data: any;
  search_filters!: search_filter;
  accountType: string = '';
  heading = '';
  toggle_sidebar = false;
  constructor(
    private globalservice: GlobalService,
    private datasearch_service: DatasearchService,
    private router: Router,
    private authentication: AuthenticationService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private commanService: CommanService,
    private busyService: BusyService,
    private ConstantService: ConstantService,
    private http: HttpClient,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const userPrivilegeData = this.authentication.getUserPrivilege();

    // if (userPrivilegeData) {
    //   const userKey = `user_${
    //     userPrivilegeData.userid ||
    //     this.authentication.getCurrentUserValue()?.userid
    //   }`;

    //   // Fetch the full privilege object for this user
    //   const allPrivileges = userPrivilegeData?.[userKey];

    //   if (
    //     allPrivileges &&
    //     allPrivileges['agropat-ultimate-discovery-suite-beta']
    //   ) {
    //     // ✅ Extract privilege for agropat-ultimate-discovery-suite-beta only
    //     const agropatPrivilege =
    //       allPrivileges['agropat-ultimate-discovery-suite-beta'];

    //     // ✅ Set privilege in the CommanService
    //     this.commanService.setUserPrivilege(agropatPrivilege);

    //     console.log(
    //       '[HomeComponent] Privilege set for: agropat-ultimate-discovery-suite-beta',
    //       agropatPrivilege
    //     );
    //   } else {
    //     console.warn(
    //       '[HomeComponent] No agropat-ultimate-discovery-suite-beta privileges found for this user.'
    //     );
    //   }
    // } else {
    //   console.warn('[HomeComponent] No user privilege data available.');
    // }

    this.authentication.getLoginUser().subscribe((val) => {
      this.isSignedIn = val;
      // this.getClients();
      this.getPlatforms();
      // this.getTestimonials();
      this.getServices();
      if (this.isSignedIn) {
        this.selectItem(0);
        // this.route.queryParams.subscribe((params) => {
        //   const findParam = params['find'];
        //   if (findParam) {
        //     // console.log("find preset")
        //     this.searchValueFromEmail = decodeURIComponent(findParam).replace(
        //       /%20/g,
        //       ' '
        //     );
        //   }
        // });
      }
    });

    this.globalservice.sendMenuIndex(0);
    this.initializedForm();

    // this.globalService.getSearchCondition().subscribe((data)=>{
    //   this.staticSuggestion('keyword', '', data);
    // });

    // Auto complete manage

    // this.SimpleSearchComponent.filterForm_normal.reset();
    // this.DynamicSearchComponent.filterForm_dynamic.reset();
    // this.AdvanceSearchComponent.filterForm_advanced.reset();
    // this.commanService.currentPage.next(1);
    // this.commanService.currentRow.next(15);
    // this.commanService.currentData.next({});
    // this.commanService.currentPrivilege.next({});
    // this.getUserPrivilege();
    this.searchByEmail();
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
      if (this.user_data.userid) {
        this.getUserAccountType(this.user_data.userid);
      }
    });
  }
  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserSubject().subscribe((val) => {
  //     this.user_data = val;

  //     this.authentication
  //       .getUserPrivilege({
  //         mode: 'GET_USER_PRIVILEGE',
  //         userid: val.userid,
  //         app_json_name: 'agroultimate',
  //         application_name: 'agroultimate Platform',
  //       })
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.privilege_json) {
  //             const privilege_json = this.ConstantService.getAppprivilege(
  //               res.privilege_json,
  //               'agroultimate',
  //               val.userid
  //             );

  //             // ✅ Store the processed privilege JSON in CommanService
  //             this.commanService.setUserPrivilege(privilege_json);
  //           }
  //         },
  //         error: (err) => {
  //           console.error('Error fetching privilege JSON:', err);
  //         },
  //       });
  //   });
  // }

  searchByEmail() {
    this.route.queryParams.subscribe((params) => {
      let encodedData = params['emailsearch'];
      if (encodedData) {
        let dataFromUrl = JSON.parse(decodeURIComponent(encodedData));
        if (dataFromUrl.searchType == 'Advance') {
          setTimeout(() => {
            this.selectedItem = 1;
          }, 500);

          setTimeout(() => {
            this.router.navigateByUrl('/');
          }, 1500);
        }
        this.globalservice.setSearchByEmail_Data(dataFromUrl);
      }
    });
  }

  // receivesimplesearchdata($event: {
  //   response: string;
  //   userid: string;
  //   gbrn: string;
  //   INCHIKEY: string;
  //   currentFilterCondition: any;
  //   application_query: string;
  //   search_filters: any;
  //   cols: any;
  //   columns: any;
  //   totalRecords: any;
  //   searchQueryGrid: string;
  // }) {

  //   // Assign values from the event object
  //   this.INCHIKEY = $event.INCHIKEY;
  //   this.gbrn = $event.gbrn;
  //   this.message = $event.response; // Extract response data
  //   this.userid = $event.userid; // Extract user ID
  //   this.currentFilterCondition = $event.currentFilterCondition;
  //   this.application_query = $event.application_query; // Assign application_query
  //   this.search_filters = $event.search_filters;
  //   this.cols = $event.cols;
  //   this.columns = $event.columns;
  //   this.totalRecords = $event.totalRecords;
  //   this.searchQueryGrid = $event.searchQueryGrid;

  //   // Extract gbrn values from the array of objects
  //   const gbrnArray = this.message.map((item: any) => item.gbrn);
  //   const inchiKeyArray = this.message.map((item: any) => item.INCHIKEY);
  //   // Call navigateToSearch with the extracted data
  //   this.navigateToSearch(gbrnArray, inchiKeyArray);

  //   // Check and process columns if available
  //   if (this.columns && this.columns.length > 0) {
  //     this.columns.forEach((column: any, index: number) => {

  //       // Add any additional processing or logic for columns here
  //     });
  //   } else {
  //     console.warn("No columns available to process.");
  //   }

  //   // Check and process cols if available
  //   if (this.cols && this.cols.length > 0) {
  //     this.cols.forEach((col: any, index: number) => {

  //     });
  //   } else {
  //     console.warn("No cols available to process.");
  //   }
  // }

  // receiveAdvancedSearchData($event: any) {
  //   this.INCHIKEY = $event.INCHIKEY;
  //   this.gbrn = $event.gbrn;
  //   this.message = $event.response; // Extract response data
  //   this.userid = $event.userid; // Extract user ID
  //   this.currentFilterCondition = $event.currentFilterCondition;
  //   this.application_query = $event.application_query; // Assign application_query
  //   this.search_filters = $event.search_filters;
  //   this.cols = $event.cols;
  //   this.columns = $event.columns;
  //   this.totalRecords = $event.totalRecords;
  //   this.searchQueryGrid = $event.searchQueryGrid;

  //   // Extract gbrn values from the array of objects
  //   const gbrnArray = this.message.map((item: any) => item.gbrn);
  //   const inchiKeyArray = this.message.map((item: any) => item.INCHIKEY);

  //   // Call navigateToSearch with the extracted data
  //   this.navigateToSearch(gbrnArray, inchiKeyArray);
  //   //  if (this.columns && this.columns.length > 0) {
  //   //     this.columns.forEach((column: any) => {
  //   //         console.log("Column Details:", column);
  //   //         // Add any additional processing or logic for columns here
  //   //     });
  //   // }
  //   if (this.cols && this.cols.length > 1) {
  //     this.cols.forEach((col: any) => {
  //       // Add any additional processing or logic for cols here
  //     });
  //   }
  // }
  // receivedynamicsearchdata($event: {
  //   response: string;
  //   userid: string;
  //   gbrn: string;
  //   INCHIKEY: string;
  //   currentFilterCondition: any;
  //   application_query: string;
  //   search_filters: any;
  //   cols: any;
  //   columns: any;
  //   totalRecords: any;
  //   searchQueryGrid: string;
  // }) {

  //   // Assign values from the event object
  //   this.INCHIKEY = $event.INCHIKEY;
  //   this.gbrn = $event.gbrn;
  //   this.message = $event.response; // Extract response data
  //   this.userid = $event.userid; // Extract user ID
  //   this.currentFilterCondition = $event.currentFilterCondition;
  //   this.application_query = $event.application_query; // Assign application_query
  //   this.search_filters = $event.search_filters;
  //   this.cols = $event.cols;
  //   this.columns = $event.columns;
  //   this.totalRecords = $event.totalRecords;
  //   this.searchQueryGrid = $event.searchQueryGrid;

  //   // Extract gbrn values from the array of objects dynamically
  //   const gbrnArray = this.message.map((item: any) => item.gbrn);
  //   const inchiKeyArray = this.message.map((item: any) => item.INCHIKEY);

  //   // Call navigateToSearch with the extracted data
  //   this.navigateToSearch(gbrnArray, inchiKeyArray);

  //   // Check and process columns if available
  //   if (this.columns && this.columns.length > 0) {
  //     this.columns.forEach((column: any, index: number) => {

  //     });
  //   } else {
  //     console.warn("No columns available to process.");
  //   }

  //   // Check and process cols if available
  //   if (this.cols && this.cols.length > 0) {
  //     this.cols.forEach((col: any, index: number) => {
  //       console.log(`Col ${index + 1} Details:`, col);
  //       // Add any additional processing or logic for cols here
  //     });
  //   } else {
  //     console.warn("No cols available to process.");
  //   }
  // }

  handlePrivilegeData(event: {
    privilege_json: any;
    userid: string;
    keyword?: string;
  }): void {
    this.privilege_json = event.privilege_json; // Store the privilege data
  }
  // getClients() {
  //   this.datasearch_service.getClients().subscribe((res) => {
  //     this.clients = res.data;
  //   });
  // }
  searchOptions: any[] = [
    // { name: 'Simple Search', value: 'SIMPLE' },
    // { name: 'Advance Search', value: 'ADVANCE' },
    // { name: 'Combinationnnnnnnnnnn Search', value: 'COMBINATION' },
    // { name: "Claim / Example Search", value: "CLAIM" }
  ];
  // navigateToSearch(gbrnArray: string[], inchiKeyArray: string[]): void {
  //   if (this.privilege_json) {

  //     // Navigate with the gbrnArray, inchiKeyArray, userId, message, privilege_json, and currentFilterCondition as part of the state
  //     this.router.navigate(['/search']);
  //   } else {
  //     console.error('Privilege data is not available!');
  //   }
  // }

  getPlatforms() {
    this.platforms = [
      {
        platform: 'AgroPat Ultimate Discovery Suite',
        shortName: 'APD',
        logo: 'menu-icon1-1.png',
        link: 'https://www.chemrobotics.com/agropat-ultimate/',
      },
      {
        platform: 'AgroPat Ultimate Generic Suite',
        shortName: 'APG',
        logo: 'menu-icon2-2.png',
        link: 'https://www.chemrobotics.com/agropat-ultimate-2  ',
      },
      {
        platform: 'Technical Route',
        shortName: 'TechR',
        logo: 'menu-icon111.png',
        link: 'https://www.chemrobotics.com/agrochem/technical-routes',
      },
      {
        platform: 'ChemiTracker - A Supplier Guide',
        shortName: 'CT',
        logo: 'menu-icon12.png',
        link: 'https://www.chemitracker.chemrobotics.com/',
      },
      {
        platform: 'Global MRL Database',
        shortName: 'MRL',
        logo: 'menu-icon33.png',
        link: 'https://www.chemrobotics.com/agrochem/mrl-database',
      },
      {
        platform: 'QuikPatent - Constraining Patent Guide',
        shortName: 'QP',
        logo: 'menu-icon14.png',
        link: 'https://quikpatent.chemrobotics.com/',
      },
      {
        platform: 'Indian Pesticide Database ',
        shortName: 'IPD',
        logo: 'menu-icon7.png',
        link: 'https://ipd.chemrobotics.com/#/',
      },
      {
        platform: 'Global Agro Product Directory ',
        shortName: 'GAPD',
        logo: 'menu-icon8.png',
        link: 'https://www.chemrobotics.com/agrochem/global-agro-product-directory',
      },
      {
        platform: 'Company Directory',
        shortName: 'CD',
        logo: 'menu-icon10.png',
        link: 'https://companydirectory.chemrobotics.com/',
      },
      {
        platform: 'PharmVetPat Ultimate',
        shortName: 'PharmVetPat',
        logo: 'PharmaVatPat.jpg',
        link: 'https://chemroboticspharma.com/pharmVetPat',
      },
      {
        platform: 'AgroPharm XIM DB Beta',
        shortName: 'XIM',
        logo: 'menu-icon17.png',
        link: 'https://agropharmexim.chemrobotics.com/#/agropharm-xim-beta',
      },
      {
        platform: 'Supplementary Protection Certificate ',
        shortName: 'SPC',
        logo: 'menu-icon-SPC.jpeg',
        link: 'https://www.chemrobotics.com/agropharm/#/spcdb',
      },
    ];
  }

  toggleVideo() {
    const video: HTMLVideoElement = this.aboutVideo.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
  initializedForm() {
    //Normal Form
    this.filterForm_normal = this.fb.group({
      ddlpatenttype: [''],
      search_type_simple: ['Exact', Validators.required],
      textautocomplete: ['', Validators.required],
    });
  }
  toggleintroVideo() {
    const video: HTMLVideoElement = this.IntroVideo.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }
  // getServices(){
  //   this.services.push({name: 'BuyActiveIngredient.com', description: 'Buy & Sell platform for Agrochemicals, Active Pharmaceutical Ingredient and their intermediates, etc.', logo: 'buy.png'});
  //   this.services.push({name: 'Product Development Support', description: 'Unique Customer Team Program to ensure that we deliver exemplary service at every level', logo: 'support.png'});
  //   this.services.push({name: 'Customer – Focused Services', description: 'Unique Customer Team Program to ensure that we deliver exemplary service at every level', logo: 'customer.png'});
  //   this.services.push({name: 'IP Services', description: 'We advise on IP right to protect aspects of : patent, copyright, trademark, industrial design etc.', logo: 'ipservices.png'});
  //   this.services.push({name: 'Patent', description: 'Provide services in drafting, filing of application and describe how to implement and use the invention.', logo: 'patent.png'});
  //   this.services.push({name: 'Intellectual property solutions', description: 'Enables business to increase revenue , optimize operations and manage IP.', logo: 'intellectualproperty.png'});
  // }
  getServices() {
    this.services = [];
    this.services.push({
      name: '<p>Technical Routes <sup>N</sup> </p>',
      description:
        'A Platform Dedicated to Agrochemical, Pharmaceutical, Specialty Chemical, Battery Chemicals, Dyes, and LED Chemical etc.',
      logo: 'gardening 1.png',
      points: [
        {
          text: 'Innovator, Chinese, Generic, Large scale and Commercial Route of Synthesis',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Intermediate Synthetic Routes with Their Application Report',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Intermediate can be searched by their CAS RN., Inchi, Inchikey and iupac name etc.',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Patent and Non-Patent References',
          icon: '../../../assets/icons/check-mark 1.png',
        },
      ],
      buttonurl: 'https://www.technicalroute.chemrobotics.com/',
    });

    this.services.push({
      name: '<p>Global Maximum Residue Limit (MRL) Database</p>',
      description:
        'MRL database has the maximum residue limits (MRLs) allowed for most pesticides used on major fruit and vegetable export crops and commodities in different counties like USA, Europe, Japan, Canada, China, India, Australia, Israel, Malaysia and Taiwan. Exporters can use this database to find out the residue limits in global markets.',
      logo: 'global-connection 1.png',
      buttonurl:
        'https://www.chemrobotics.com/agro-suite/mrl-database?access_key=MTA5Ng%3D%3D',
    });

    this.services.push({
      name: '<p>QuikPatent Database</p>',
      description: 'Agrochemical Product Launch Constraining Patents Guide',
      logo: 'Page-1.png',
      points: [
        {
          text: 'Generic Constraining Patents',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Compound, Formulaion, Combination (Mixture), Process and Polymorph Patents',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Patent Watch',
          icon: '../../../assets/icons/check-mark 1.png',
        },
        {
          text: 'Competitor Watch',
          icon: '../../../assets/icons/check-mark 1.png',
        },
      ],
      buttonurl: 'https://quikpatent.chemrobotics.com/?access_key=MTA5Ng%3D%3D',
    });
  }

  // getTestimonials() {
  //   this.testimonials.push({
  //     description:
  //       'We have been waiting on this product and now that we have installed a few. We think it will make the industry by storm.',
  //     given_by: 'Ryan Oliver',
  //     designation: 'Design Manager at Kiluna',
  //     image: '../../../assets/img/testimages/Photo1.png',
  //   });
  //   this.testimonials.push({
  //     description:
  //       'Thank you for introducing me to Cham Robotics! e like how the system gives updates to us and the homeowner as well to give us a real-time update on how everything is working.',
  //     given_by: 'Gladina Samantha',
  //     designation: 'CEO Jobdesk United, LLC',
  //     image: '../../../assets/img/testimages/Photo2.png',
  //   });
  // }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isVisible = window.pageYOffset > 70;
    this.transparent = !this.isVisible;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  demoRequest() {
    this.scrollToTop();

    this.router.navigate(['/demo_request']);
  }

  handleChangeTabValue(tab: string) {
    this.tabvalue = tab;
    this.showTab = false;
  }

  handleShowTab() {
    this.showTab = !this.showTab;
  }

  isAuthenticated(): boolean {
    // return this.loginService.isAuthenticated();
    return this.auth;
  }

  closeModal() {
    const modalElement = this.priviledgeModal.nativeElement;
    modalElement.classList.remove('show');
    modalElement.style.display = 'none';
    modalElement.setAttribute('aria-hidden', 'true');
    modalElement.removeAttribute('aria-modal');
    modalElement.removeAttribute('role');
  }

  openPriviledgeModal(data: any) {
    this.LimitValue = data;
    const modalElement = this.priviledgeModal.nativeElement;
    modalElement.classList.add('show');
    modalElement.style.display = 'block';
    modalElement.setAttribute('aria-hidden', 'false');
    modalElement.setAttribute('aria-modal', 'true');
    modalElement.setAttribute('role', 'dialog');
  }

  selectItem(index: number): void {
    this.selectedItem = index;
  }

  newsItems = [
    {
      title:
        'BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      summary:
        'Summary :- BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in SpainBASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      image: '../../../assets/img/carousel_img/carousel_01.webp',
    },
    {
      title:
        'BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      summary:
        'Summary :- BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in SpainBASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      image: '../../../assets/img/carousel_img/carousel_01.webp',
    },
    {
      title:
        'BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      summary:
        'Summary :- BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in SpainBASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      image: '../../../assets/img/carousel_img/carousel_02.webp',
    },
    {
      title:
        'BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      summary:
        'Summary :- Revysol® is the first Isopropanol-Azole in the market. Its unique chemical constellation allows the molecule to assume different conformations easily and to...',
      image: '../../../assets/img/carousel_img/carousel_03.webp',
    },
    {
      title:
        'BASF Launches Fungicide Revyona (75 g/L Mefentrifluconazole) in Spain',
      summary:
        'Summary :- Revysol® is the first Isopropanol-Azole in the market. Its unique chemical constellation allows the molecule to assume different conformations easily and to...',
      image: 'https://via.placeholder.com/600x400.png?text=Image+3',
    },
    // Add more items here...
  ];

  // Slide to the previous set of cards
  prevSlide(slider: HTMLElement) {
    slider.scrollBy({
      left: -slider.clientWidth,
      behavior: 'smooth',
    });
  }

  // Slide to the next set of cards
  nextSlide(slider: HTMLElement) {
    slider.scrollBy({
      left: slider.clientWidth,
      behavior: 'smooth',
    });
  }
  signIn() {
    this.isSignedIn = true;
  }

  openSignInForm() {
    this.globalservice.sendOpenSignInModal(true);
    // console.log("")
  }
  openSignUpForm() {
    this.globalservice.sendOpenSignUpModal(true);
    // console.log("")
  }
  getUserAccountType(userId: string) {
    this.datasearch_service.getUserAccountType(userId).subscribe({
      next: (res: any) => {
        this.accountType = res.account_type || '';
      },
      error: (err) => {
        console.error('Error while fetching account type:', err); // On error
      },
    });
  }

  downloadPdf() {
    this.http
      .get('http://localhost:5001/download-pdf', { responseType: 'blob' })
      .subscribe((pdfBlob) => {
        const blob = new Blob([pdfBlob], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'invoice.pdf';
        link.click();
      });
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string){
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean){
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }
}
